function InputLabel({ id, disabled = false, label }: { id?: string, disabled: boolean, label?: string }) {
    const disabledLabel = disabled ? "text-gray-400" : "text-gray-700";
  
    const renderLabel = () => {
      if (!label) return null;
      if (label.endsWith("*")) {
        return (
          <>
            {label.slice(0, -1)}
            <span className="text-red-500">*</span>
          </>
        );
      }
      return label;
    };
  
    return label ? (
      <label className={`block tracking-wide text-sm font-bold mb-1 ${disabledLabel}`} htmlFor={id}>
        {renderLabel()}
      </label>
    ) : (
      <></>
    );
  }
  
  export default InputLabel;
  